/* jshint esversion: 6 */

/***********************************************************************
 * reads the browser cookie and extracts the lesson info,
 * stored by the ttkf html4 player
 ***********************************************************************/

import {Core} from "common/Core.js";
import {decryptData} from "../../encryption/decryptData";

const chunk = (entries, size) => {

    const resultMap = new Map();
    for (let i = 0; i < entries.length; i += size) {
        resultMap.set(entries[i], entries[i + 1]);
    }
    return resultMap;
};

function isUserEntry(entry, userId) {

    if (entry.startsWith(`${userId}=`)) {
        return true;
    }

    if (userId.toLowerCase() === "user") {
        return entry.startsWith("undefined=");
    }

    return false;
}

function parseEntry(entry) {
    const result = new Map();
    const lessonMap = getLessonMap(entry);
    lessonMap.forEach((data, id) => {
        if (isEntryValid(id, data)) {
            result.set(id, getValues(data));
        }
    });
    return result;
}

/**
 * structure of the data should be alternating lessonId, lessonData
 * e.g.: *e4o0lz6jusge8g8a4bdanaceklm*$f$f$00:00:36$p$100$I61679$$$$$*95gcfrw2s5gvbuu37h8vuotpdlm*$f$f$00:01:43$f$25$I212791$$$s$$
 * @param userEntry
 * @returns {Map<String, String>}
 */
function getLessonMap(userEntry) {
    const data = getData(userEntry);
    return new Map(chunk(data.split('*'), 2));
}

function getData(entry) {
    const data = entry.substring(entry.indexOf("=") + 1, entry.length);
    return decryptData(data);
}

function isEntryValid(id, data) {
    return id && data && data.includes("$");
}

/**
 * retrieves the relevant values of a sequenceData string
 * @param sSequenceValues eg. "$f$f$00:55:22$p$100$I609510$$$$$"
 * @returns {{lessonStatus: (*|string), score: (*|string), lessonLocation: (*|string)}}
 */
function getValues(sSequenceValues) {

    const sequenceValues = sSequenceValues.split('$'),
        score = Number(sequenceValues[5]);

    return {
        score: isNaN(score) ? 0 : score,
        lessonStatus: sequenceValues[4],
        lessonLocation: sequenceValues[6]
    }
}

// revealing public api
export const CookieDataReader = {
    read: (userId) => {

        let result = new Map();
        const cookieDataEntries = document.cookie.split(";");
        cookieDataEntries.forEach((cookieEntry) => {
            const entry = cookieEntry.trim();
            if (isUserEntry(entry, userId)) {
                const entryMap = parseEntry(entry);
                result = Core.mergeMaps(result, entryMap);
            }
        });
        return result;
    }
};
